import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ButtonIcon from '../ButtonIcon/ButtonIcon';
import styles from './Footer.module.scss';


const Footer = () => (
  <footer className={styles.footer}>
    <h3 className={styles.title}>Get Social</h3>
    <div className={styles.social}>
      <ButtonIcon link="https://www.instagram.com/themeltingpotkitchen" icon={<FontAwesomeIcon icon={['fab', 'instagram']} />} />
      <ButtonIcon link="https://www.facebook.com/themeltingpotkitchen" icon={<FontAwesomeIcon icon={['fab', 'facebook-f']} />} />
      <ButtonIcon link="http://www.idesignpixels.com" icon={<FontAwesomeIcon icon={['fas', 'code']} />} />
    </div>
  </footer>
);

export default Footer;